import React, { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { ButtonV4 } from 'components';
import { _t, lockBodyScroll } from 'utils';

import iconOffer from 'assets/img/vacancies-v4/icon-offer.svg';
import iconTask from 'assets/img/vacancies-v4/icon-task.svg';

import { Vacancy } from '../data';
import styles from './styles.module.scss';

type Props = {
  vacancy: Vacancy;
  onClose: () => void;
  onApply: () => void;
};

const VacancyDetail: FC<Props> = ({ vacancy, onClose, onApply }) => {
  useEffect(() => lockBodyScroll(), []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return createPortal(
    <div className={styles.root} role="dialog" aria-modal="true" aria-label={_t('Описание вакансии')}>
      <div className={styles.backdrop} onClick={onClose} role="presentation" />
      <aside className={styles.panel}>
        <div className={styles.head}>
          <h2 className={styles.headTitle}>{_t('Описание вакансии')}</h2>
          <button
            type="button"
            className={styles.close}
            aria-label={_t('Закрыть')}
            onClick={onClose}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" />
            </svg>
          </button>
        </div>

        <div className={styles.body}>
          <h3 className={styles.title}>{_t(vacancy.fullTitle)}</h3>

          <section className={styles.block}>
            <h4 className={styles.blockTitle}>{_t('В ваши задачи будет входить:')}</h4>
            <ul className={styles.list}>
              {vacancy.tasks.map((item) => (
                <li key={item} className={styles.listItem}>
                  <img src={iconTask} alt="" className={styles.icon} width={32} height={32} />
                  <span className={styles.listText}>{_t(item)}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className={styles.block}>
            <h4 className={styles.blockTitle}>{_t('Вам подойдёт эта вакансия, если:')}</h4>
            <ul className={styles.list}>
              {vacancy.fit.map((item) => (
                <li key={item.title} className={styles.pointItem}>
                  <img src={iconTask} alt="" className={styles.icon} width={32} height={32} />
                  <div className={styles.pointBody}>
                    <div className={styles.pointTitle}>{_t(item.title)}</div>
                    <div className={styles.pointText}>{_t(item.text)}</div>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <section className={styles.blockOffer}>
            <h4 className={styles.blockTitle}>{_t('Мы предлагаем:')}</h4>
            <ul className={styles.list}>
              {vacancy.offer.map((item) => (
                <li key={item.title} className={styles.pointItem}>
                  <img src={iconOffer} alt="" className={styles.icon} width={32} height={32} />
                  <div className={styles.pointBody}>
                    <div className={styles.pointTitle}>{_t(item.title)}</div>
                    <div className={styles.pointText}>{_t(item.text)}</div>
                  </div>
                </li>
              ))}
            </ul>
            <div className={styles.apply}>
              <ButtonV4
                label="Откликнуться на вакансию"
                variant="solid"
                tone="primary"
                onClick={onApply}
              />
            </div>
          </section>
        </div>
      </aside>
    </div>,
    document.body,
  );
};

export default VacancyDetail;
